import { teamAdapter } from "@store/teams/teams-slice";
/** Stores how many members are returned from the backend per request. */
export const API_MEMBERS_PER_REQUEST = 30;

/**
 * Removes locally a member from a team, by removing it from sample members array
 * attribute of the team if members are available.
 *
 * When the removed member is the one whose teams are currently displayed in the
 * member profile "Teams" tab, the team is also removed from "memberTeams.ids" so
 * the corresponding row disappears from the member teams table.
 */
export function removeLocalMemberFromTeam(state, result) {
  const team = teamAdapter.getSelectors().selectById(state, result.teamId);
  if (team) {
    const updatedMembers = state.selectedTeam.members;
    result.memberIds.forEach(memberId => {
      if (updatedMembers[memberId]) {
        delete updatedMembers[memberId];
        state.selectedTeam.totalCount -= 1;
      }
    });
    state.selectedTeam.members = updatedMembers;
  }

  // When the removed member is the one whose teams are shown on the member
  // profile "Teams" tab, drop this team from that list as well.
  if (state.memberTeams.memberIdentity && result.memberIds.includes(state.memberTeams.memberIdentity)) {
    state.memberTeams.ids = state.memberTeams.ids.filter(id => id !== result.teamId);
  }
  const {
    memberIdentity
  } = state.memberTeams;
  if (memberIdentity && result.memberIds.includes(memberIdentity)) {
    state.memberTeams.ids = state.memberTeams.ids.filter(teamId => teamId !== result.teamId);
  }
}